<cc-signon-table-location [point]="column.point"></cc-signon-table-location>
